import { FocusEvent, forwardRef, ForwardRefRenderFunction } from 'react';
import { Box, Flex, Label } from '@qga/roo-ui/components';
import { CheckInInput, CheckOutInput, InputDivider, LabelText } from './primitives';

interface DateRangeDisplayProps {
  startDatePlaceholder: string;
  endDatePlaceholder: string;
  startDateDisplayValue: string;
  endDateDisplayValue: string;
  onStartDateFocus: (event: FocusEvent<HTMLInputElement>) => void;
  onEndDateFocus: (event: FocusEvent<HTMLInputElement>) => void;
  [key: string]: any;
}

const DateRangeDisplay: ForwardRefRenderFunction<HTMLDivElement, DateRangeDisplayProps> = (
  {
    startDatePlaceholder,
    endDatePlaceholder,
    startDateDisplayValue,
    endDateDisplayValue,
    startDateFocused,
    endDateFocused,
    onStartDateFocus,
    onEndDateFocus,
    ...rest
  },
  ref,
) => (
  <Flex display="flex" ref={ref} {...rest}>
    <Label>
      <LabelText>Check-in date</LabelText>
      <Box position="relative">
        <CheckInInput
          iconName="calendar"
          placeholder={startDatePlaceholder}
          value={startDateDisplayValue}
          focused={startDateFocused}
          onFocus={onStartDateFocus}
          readOnly
        />
        <InputDivider focused={startDateFocused || endDateFocused} />
      </Box>
    </Label>
    <Label>
      <LabelText>Check-out date</LabelText>
      <CheckOutInput
        placeholder={endDatePlaceholder}
        value={endDateDisplayValue}
        focused={endDateFocused}
        onFocus={onEndDateFocus}
        readOnly
      />
    </Label>
  </Flex>
);

export default forwardRef(DateRangeDisplay);
